import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseurl, imgurl } from "../baseurl";

function CategoryMobile() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${baseurl}getCategoriesWithSubcategories`);
        if (res.data?.categories) {
          setCategories(res.data.categories);
        }
      } catch (err) {
        console.error("Error fetching categories:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // ✳️ Limit to 7 categories
  const visibleCategories = categories.slice(0, 7);

  return (
    <>
      <div className="container-fluid py-2">
        <div className="row g-2">
          {loading
            ? [...Array(8)].map((_, i) => (
                <div key={i} className="col-3">
                  <div className="category-box skeleton text-center p-2">
                    <div className="image-skeleton mx-auto"></div>
                    <div className="text-skeleton mx-auto mt-2"></div>
                  </div>
                </div>
              ))
            : (
              <>
                {visibleCategories.map((cat) => (
                  <div className="col-3" key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="category-box text-center p-2"
                    >
                      <div className="category-img-wrapper mx-auto">
                        <img
                          src={`${imgurl}${cat.image}`}
                          alt={cat.name}
                          className="category-img rounded-circle"
                        />
                      </div>
                      <div className="category-name mt-1">{cat.name}</div>
                    </Link>
                  </div>
                ))}

                {/* 🟢 "More" Button */}
                <div className="col-3">
                  <Link to="/all-categories" className="category-box text-center p-2 more-box">
                    <div className="category-img-wrapper mx-auto d-flex align-items-center justify-content-center">
                      <span className="more-plus">+</span>
                    </div>
                    <div className="category-name mt-1">More</div>
                  </Link>
                </div>
              </>
            )}
        </div>
      </div>

      <style>{`
        .category-box {
          background: #fff;
          border-radius: 10px;
          transition: all 0.3s ease;
          text-decoration: none;
          color: #333;
        }

        .category-box:hover {
          transform: translateY(-3px);
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }

        .category-img-wrapper {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          overflow: hidden;
          background: #f5f5f5;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .category-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }

        .category-name {
          font-size: 13px;
          font-weight: 500;
          color: #333;
          word-break: break-word;
        }

        /* "More" Box */
        .more-box .category-img-wrapper {
          background: #ffecec;
          border: 2px dashed #ff6666;
        }

        .more-plus {
          font-size: 28px;
          font-weight: bold;
          color: #ff4444;
        }

        /* Skeleton loader */
        .skeleton {
          background: #f2f2f2;
          animation: pulse 1.5s infinite;
          border-radius: 8px;
        }

        .image-skeleton {
          height: 70px;
          width: 70px;
          border-radius: 50%;
          background: #ddd;
        }

        .text-skeleton {
          width: 50%;
          height: 10px;
          background: #ddd;
          border-radius: 4px;
        }

        @keyframes pulse {
          0% { background-color: #f2f2f2; }
          50% { background-color: #e3e3e3; }
          100% { background-color: #f2f2f2; }
        }

        @media (max-width: 576px) {
          .category-name {
            font-size: 12px;
          }
        }
      `}</style>
    </>
  );
}

export default CategoryMobile;
